import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { startTrialTimer, stopTrialTimer } from "@/useModules/useTrial/use";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/newArticle/knowKeyboard",
    name: "KnowKeyboard",
    component: () => import("../views/newArticle/KnowKeyboard.vue"),
  },
  {
    path: "/englishTypewriting/index",
    name: "englishTypewriting",
    component: () => import("../views/englishTypewriting/index.vue"),
  },
  {
    path: "/englishTypewriting/fingeringPractice",
    name: "FingeringPractice",
    component: () =>
      import("../views/englishTypewriting/fingeringPractice.vue"),
  },
  {
    path: "/englishTypewriting/letterKeyTest",
    name: "LetterKeyTest",
    component: () => import("../views/englishTypewriting/letterKeyTest.vue"),
  },
  {
    path: "/englishTypewriting/testWordPractice",
    name: "TestWordPractice",
    component: () => import("../views/englishTypewriting/testWordPractice.vue"),
  },
  {
    path: "/englishTypewriting/testStatementsPractice",
    name: "TestStatementsPractice",
    component: () =>
      import("../views/englishTypewriting/testStatementsPractice.vue"),
  },
  {
    path: "/englishTypewriting/wordPractice",
    name: "WordPractice",
    component: () => import("../views/englishTypewriting/wordPractice.vue"),
  },
  {
    path: "/englishTypewriting/statementsPractice",
    name: "StatementsPractice",
    component: () =>
      import("../views/englishTypewriting/statementsPractice.vue"),
  },
  {
    path: "/englishTypewriting/articlePractice",
    name: "ArticlePractice",
    component: () => import("../views/englishTypewriting/articlePractice.vue"),
  },
  {
    path: "/englishTypewriting/testArticlePractice",
    name: "TestArticlePractice",
    component: () =>
      import("../views/englishTypewriting/testArticlePractice.vue"),
  },
  {
    path: "/typingGame/index",
    name: "TypingGame",
    component: () => import("../views/typingGame/index.vue"),
    // children: [
    //   {
    //     path: "gameRun",
    //     name: "GameRun",
    //     component: () => import("../views/typingGame/gameRun.vue"),
    //   },
    // ],
  },
  {
    path: "/typingGame/gameRun",
    name: "GameRun",
    component: () => import("../views/typingGame/gameRun.vue"),
  },
  {
    path: "/pinyinTyping/index",
    name: "PinyinTyping",
    component: () => import("../views/pinyinTyping/index.vue"),
  },
  {
    path: "/pinyinTyping/phrasePractice",
    name: "PhrasePractice",
    component: () => import("../views/pinyinTyping/phrasePractice.vue"),
  },
  {
    path: "/pinyinTyping/testSyllablePractice",
    name: "TestSyllablePractice",
    component: () => import("../views/pinyinTyping/testSyllablePractice.vue"),
  },
  {
    path: "/pinyinTyping/testSeparateWord",
    name: "TestSeparateWord",
    component: () => import("../views/pinyinTyping/testSeparateWord.vue"),
  },
  {
    path: "/pinyinTyping/testPhrasePractice",
    name: "TestPhrasePractice",
    component: () => import("../views/pinyinTyping/testPhrasePractice.vue"),
  },
  {
    path: "/pinyinTyping/testArticlePractice",
    name: "TestArticlePractice",
    component: () => import("../views/pinyinTyping/testArticlePractice.vue"),
  },
  {
    path: "/pinyinTyping/separateWord",
    name: "SeparateWord",
    component: () => import("../views/pinyinTyping/separateWord.vue"),
  },
  {
    path: "/pinyinTyping/articlePractice",
    name: "ArticlePractice",
    component: () => import("../views/pinyinTyping/articlePractice.vue"),
  },
  {
    path: "/pinyinTyping/syllablePractice",
    name: "SyllablePractice",
    component: () => import("../views/pinyinTyping/syllablePractice.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

const getNeedStartTrial = () => {
  const pathList = ["englishTypewriting", "typingGame", "pinyinTyping"];
  const startTrialList = routes
    .map((item) => {
      const existIndex = pathList.findIndex((path) => item.path.includes(path));
      if (existIndex === -1) return;
      if (item.path.endsWith("index")) return;
      return item.path;
    })
    .filter((item) => item);
  return startTrialList;
};
const needStartTrialList = getNeedStartTrial();
router.beforeEach((to, from, next) => {
  if (needStartTrialList.findIndex((item) => to.path.includes(item)) !== -1) {
    startTrialTimer();
  } else {
    stopTrialTimer();
  }
  next();
});

export default router;
export { needStartTrialList };

